'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookOrderTracking = require('@narvar/nth-hook-order-tracking');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function (Product) {
  Product["narvarjs"] = "narvarjs";
  Product["narvarjsBuild"] = "narvarjs_build";
  Product["narvarjsTranslations"] = "narvarjs_translations";
})(exports.Product || (exports.Product = {}));
(function (ExperienceHostEnum) {
  ExperienceHostEnum["NARVAR"] = "NARVAR";
  ExperienceHostEnum["EMBED"] = "EMBED";
})(exports.ExperienceHostEnum || (exports.ExperienceHostEnum = {}));
(function (StatusCode) {
  StatusCode["SHPD"] = "SHPD";
  StatusCode["INTR"] = "INTR";
  StatusCode["OFDL"] = "OFDL";
  StatusCode["DLVD"] = "DLVD";
  StatusCode["DLPP"] = "DLPP";
  StatusCode["PUBC"] = "PUBC";
  StatusCode["ITTS"] = "ITTS";
  StatusCode["ITPP"] = "ITPP";
  StatusCode["DLTS"] = "DLTS";
  StatusCode["EXCP"] = "EXCP";
  StatusCode["UNDL"] = "UNDL";
  StatusCode["BOSS"] = "BOSS";
  StatusCode["BOPIS"] = "BOPIS";
  StatusCode["UNKN"] = "UNKN";
})(exports.StatusCode || (exports.StatusCode = {}));
var DEFAULT_PAGE_CONTEXT = {
  product: exports.Product.narvarjs,
  experienceHost: 'NARVAR',
  retailerMoniker: 'DEFAULT_RETAILER',
  versionName: 'narvar',
  isFallbackView: false,
  segmentId: undefined,
  segmentName: undefined,
  localeLanguage: undefined,
  localeCountry: undefined,
  type: undefined,
  trackingType: undefined,
  category: undefined,
  trackingStatus: undefined,
  trackingStatusCode: undefined,
  carrier: undefined,
  trackingNumbers: undefined,
  orderNumbers: undefined,
  requestUrl: undefined,
  destinationZip: undefined,
  originZip: undefined,
  originCountry: undefined,
  destinationCountry: undefined,
  service: undefined,
  orderDate: undefined,
  shipDate: undefined,
  retailerDcId: undefined,
  productCategory: undefined,
  promiseDate: undefined,
  orderApiEnabled: undefined,
  secured: undefined,
  itemIds: undefined,
  itemNumber: undefined,
  mainShipmentId: undefined,
  email: undefined,
  phone: undefined,
  cache: undefined,
  orderType: undefined,
  token: undefined,
  orderTrackingData: undefined
};
var formatPageContext = function formatPageContext(oldState) {
  var carrier = typeof oldState.carrier === 'string' ? oldState.carrier.toLowerCase() : undefined;
  return _objectSpread(_objectSpread({}, oldState), {}, {
    carrier: carrier
  });
};
var PageContextContext = /*#__PURE__*/React.createContext({
  state: DEFAULT_PAGE_CONTEXT,
  update: function update() {}
});
var PageProvider = function PageProvider(_ref) {
  var _state$orderTrackingD;
  var children = _ref.children,
    _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? DEFAULT_PAGE_CONTEXT : _ref$initialState;
  var _React$useState = React.useState(formatPageContext(initialState)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var update = React.useCallback(function (next) {
    setState(formatPageContext(next));
  }, []);
  var value = React.useMemo(function () {
    return {
      state: state,
      update: update
    };
  }, [state, update]);
  return /*#__PURE__*/React.createElement(PageContextContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(nthHookTheme.LomaThemeConfigProvider, {
    product: 'narvarjs',
    retailerMoniker: state.retailerMoniker,
    versionName: state.versionName,
    localeLanguage: state.localeLanguage,
    localeCountry: state.localeCountry,
    cache: state.cache
  }, /*#__PURE__*/React.createElement(nthHookTranslations.LomaTranslationsConfigProvider, {
    product: 'narvarjs_translations',
    retailerMoniker: state.retailerMoniker,
    versionName: state.versionName,
    localeLanguage: state.localeLanguage,
    localeCountry: state.localeCountry,
    category: state.trackingStatusCode,
    status: state.trackingStatus,
    type: state.trackingType
  }, /*#__PURE__*/React.createElement(nthHookSettings.LomaSettingsConfigProvider, {
    product: 'narvarjs',
    retailerMoniker: state.retailerMoniker,
    versionName: state.versionName,
    localeLanguage: state.localeLanguage,
    localeCountry: state.localeCountry
  }, /*#__PURE__*/React.createElement(nthHookGlobalSettings.LomaGlobalSettingsConfigProvider, {
    retailerMoniker: state.retailerMoniker,
    localeLanguage: state.localeLanguage,
    localeCountry: state.localeCountry
  }, /*#__PURE__*/React.createElement(nthHookOrderTracking.OrderTrackingProvider, {
    value: (_state$orderTrackingD = state.orderTrackingData) !== null && _state$orderTrackingD !== void 0 ? _state$orderTrackingD : null
  }, children))))));
};
var usePageContext = function usePageContext() {
  return React.useContext(PageContextContext);
};

exports.DEFAULT_PAGE_CONTEXT = DEFAULT_PAGE_CONTEXT;
exports.PageProvider = PageProvider;
exports.formatPageContext = formatPageContext;
exports.usePageContext = usePageContext;
